import { SubscribeBanner } from '@/components/billing/SubscribeBanner';
import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

interface DashboardLayoutProps {
  children: ReactNode;
  className?: string;
}

export function DashboardLayout({ children, className }: DashboardLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-dark noise-overlay overflow-x-hidden">
      <Sidebar />
      <div className="lg:pl-64">
        <TopBar />
        <main className={cn('p-4 lg:p-8 overflow-x-hidden', className)}>
          <div className="mx-auto max-w-7xl space-y-4">
            {/* FEAT-APR08-001: persistent freemium / past_due / cancelled / paused
                / gym_not_active subscribe banner. Renders nothing when the user
                is not frozen. */}
            <SubscribeBanner />
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
